import { NgModule } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { ConnectTypeModalComponent } from './modals/connect-type-modal/connect-type-modal.component';
import { FilterProductsModalComponent } from './modals/filter-products-modal/filter-products-modal.component';
import { PhIconComponent } from './components/ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from './components/ph-icon-wrapper/ph-icon-wrapper.component';
import { LayoutHistoryComponent } from './components/layout-history/layout-history.component';
import { PhotoReportModalComponent } from './modals/photo-report-modal/photo-report-modal.component';
import { PhLinkButtonComponent } from './components/link-button/ph-link-button.component';
import { PhButtonComponent } from './components/ph-button/ph-button.component';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { InfoModalComponent } from './modals/info-modal/info-modal.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { PickerComponent } from './components/picker/picker.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FiltersPanelComponent } from './components/filters-panel/filters-panel.component';
import { SelectedPanelComponent } from './components/selected-panel/selected-panel.component';
import { EquipmentModelComponent } from './components/equipment-model/equipment-model.component';
import { ActiveRoutePipe } from './pipes/active-route.pipe';
import { GetLinkPipe } from './pipes/get-link.pipe';
import { NamesListPipe } from './pipes/names-list';
import { HasAccessPipe } from './pipes/has-access.pipe';
import { HasExtensionPipe } from './pipes/has-extension.pipe';
import { HasFeaturePipe } from './pipes/has-feature.pipe';
import { CutArrayPipe } from './pipes/cut-array.pipe';
import { CutStringPipe } from './pipes/cut-string.pipe';
import { FilterByPipe } from './pipes/filter-by.pipe';
import { FilterCallbackPipe } from './pipes/filter-callback.pipe';
import { JoinArrayPipe } from './pipes/join-array.pipe';
import { WindowScrollDirective } from './directives/window-scroll.directive';
import { LoaderComponent } from './components/loader/loader.component';
import { PhLoaderComponent } from './components/ph-loader/ph-loader.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { PhTooltipDirective } from './directives/ph-tooltip.directive';
import { TableComponent } from './components/table/table.component';
import { SanitizerPipe } from './pipes/sanitizer.pipe';
import { PlanogramComponent } from '../planogram/components/planogram/planogram.component';
import { TreeItemCheckboxComponent } from '../planogram/planogram-edit/components/add-products-panel/tree-item-checkbox/tree-item-checkbox.component';
import { TreeCheckboxComponent } from './components/filters-panel/tree-checkbox/tree-checkbox.component';
import { TreeRadioComponent } from './components/filters-panel/tree-radio/tree-radio.component';
import { TreeFilterComponent } from './components/filters-panel/tree-filter/tree-filter.component';
import { AutocompleteSimpleComponent } from './components/autocomplete-simple/autocomplete-simple.component';
import { ExecutionStandComponent } from '../execution/pages/execution-stand/execution-stand.component';
import { ScrollToDirective } from './directives/scroll-to.directive';
import { ViewedDirective } from './directives/viewed.directive';
import { MenuDropdownDirective } from './directives/menu-dropdown.directive';
import { RotateProductsModalComponent } from './modals/rotate-products-modal/rotate-products-modal.component';
import { ComplexDeadlineModalComponent } from './modals/complex-deadline-modal/complex-deadline-modal.component';
import { CustomHeader } from './components/ph-datepicker/ph-datepicker/custom-header/custom-header.component';
import { MultiExecutionComponent } from './components/multi-execution/multi-execution.component';
import { ZoomComponent } from './components/zoom/zoom.component';
import { ConfigureTableColumnsModalComponent } from './modals/configure-table-columns-modal/configure-table-columns-modal.component';
import { HighchartsComponent } from './components/highcharts/highcharts.component';
import { FilterLibraryModalComponent } from '../plan/plan-edit/modals/filter-library/filter-library.component';
import { NestedTableComponent } from './components/nested-table/nested-table.component';
import { DropdownLinksComponent } from './components/dropdown-links/dropdown-links.component';
import { UserLogoGenerateComponent } from './components/user-logo-generate/user-logo-generate.component';
import { PhDatepickerComponent } from './components/ph-datepicker/ph-datepicker/ph-datepicker.component';
import { PhSimpleTableComponent } from './components/ph-simple-table/ph-simple-table.component';
import { PhListComponent } from './components/ph-list/ph-list.component';
import { StringDtypeComponent } from './components/dtypes/string-dtype/string-dtype.component';
import { TooltipDtypeComponent } from './components/dtypes/tooltip-dtype/tooltip-dtype.component';
import { LastChangeDtypeComponent } from './components/dtypes/last-change-dtype/last-change-dtype.component';
import { ProductNameDtypeComponent } from './components/dtypes/product-name-dtype/product-name-dtype.component';
import { NumberDtypeComponent } from './components/dtypes/number-dtype/number-dtype.component';
import { LinkDtypeComponent } from './components/dtypes/link-dtype/link-dtype.component';
import { DatetimeDtypeComponent } from './components/dtypes/datetime-dtype/datetime-dtype.component';
import { LayoutParamsDtypeComponent } from './components/dtypes/layout-params-dtype/layout-params-dtype.component';
import { DtypeInjectorPipe } from './pipes/dtype-injector.pipe';
import { LinkTypePipe } from './pipes/link-type.pipe';
import { SidePanelComponent } from './components/side-panel/side-panel.component';
import { TimeTrackerComponent } from './components/time-tracker/time-tracker.component';
import { TimersMenuComponent } from './components/timers-menu/timers-menu.component';
import { EquipmentsDownloadModalComponent } from './modals/equipments-download-modal/equipments-download-modal.component';
import { EquipmentCreateNameModalComponent } from '../equipment/modals/equipment-create-name-modal/equipment-create-name-modal.component';
import { DownloadMenuComponent } from './components/download-menu/download-menu.component';
import { PhSnackBarComponent } from './components/ph-snack-bar/ph-snack-bar.component';
import { PhEditableTableComponent } from './components/ph-editable-table/ph-editable-table.component';
import { ExpiredComponent } from './components/expired/expired.component';
import { TariffComparisonComponent } from './components/tariff-comparison/tariff-comparison.component';
import { DatePipe } from '@angular/common';
import { DependencyModule } from './modules/dependency.module';
import { RequiredFieldPipe } from './pipes/required-field.pipe';
import { MeasurementUnitPipe } from './pipes/measurement-unit.pipe';
import { TreeMultiFilterComponent } from './components/filters-panel/tree-multi-filter/tree-multi-filter.component';
import { CheckboxStatusPipe } from './pipes/checkbox-status.pipe';
import { PlanStatusButtonDtypeComponent } from './components/dtypes/plan-status-button-dtype/plan-status-button-dtype.component';
import { ColorTagsDirective } from './directives/color-tags.directive';
import { ProductCardDrawerComponent } from './components/product-card-drawer/product-card-drawer.component';
import { ImageSelectComponent } from './components/image-select/image-select.component';
import { UploadPhotoComponent } from './components/upload-photo/upload-photo.component';
import { ProductTypeTitlePipe } from './pipes/product-type-title.pipe';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { PhTableComponent } from './components/ph-table/ph-table.component';
import { PhBarChartComponent } from './components/ph-bar-chart/ph-bar-chart.component';
import { ColorTableRowPipe } from './pipes/color-table-row.pipe';
import { PhGroupedSelectComponent } from './components/ph-grouped-select/ph-grouped-select.component';
import { ColumnsSettingsModalComponent } from './modals/columns-settings-modal/columns-settings-modal.component';
import { ThousandSeparatorPipe } from './pipes/thousand-separator.pipe';
import { BarChartSettingsModalComponent } from './modals/bar-chart-settings-modal/bar-chart-settings-modal.component';
import { TableActiveRowPipe } from './pipes/table-active-row.pipe';
import { SearchComponent } from './components/search/search.component';
import { HighlightOptionsComponent } from './components/highlight-options/highlight-options.component';
import { HotkeyTooltipComponent } from './components/hotkey-tooltip/hotkey-tooltip.component';
import { ImagesViewModalComponent } from './modals/images-view-modal/images-view-modal.component';
import { OnboardingModalComponent } from './modals/onboarding-modal/onboarding-modal.component';
import { GetFullVersionModalComponent } from './modals/get-full-version-modal/get-full-version-modal.component';
import { PersonalSettingsComponent } from './components/personal-settings/personal-settings.component';
import { AIAssistantComponent } from './components/ai-assistant/ai-assistant.component';
import { AIRuleComponent } from '../planogram/planogram-edit/components/layout-rules/ai-rule/ai-rule.component';
import { ProductListAddButtonDtypeComponent } from './components/dtypes/product-list-add-button-dtype/product-list-add-button-dtype.component';
import { DeadlineDateDtypeComponent } from './components/dtypes/deadline-date-dtype/deadline-date-dtype.component';
import { PlanogramsWorkspaceComponent } from '../dashboard/components/planograms-workspace/planograms-workspace.component';
import { WelcomeDemoFormModalComponent } from './modals/welcome-demo-form-modal/welcome-demo-form-modal.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { PlanogramCompletionComponent } from './components/planogram-completion/planogram-completion.component';
import { PlanogramConfigurationComponent } from '../plan/plan-edit/components/planogram-configuration/planogram-configuration.component';
import { UsersActivityComponent } from './components/users-activity/users-activity.component';
import { UnitConverterPipe } from './pipes/unit-converter.pipe';
import { MeasurementUnitTranslatePipe } from './pipes/measurement-unit-translate.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { BlogArticlesComponent } from './components/blog-articles/blog-articles.component';
import { InfiniteScrollFixDirective } from './directives/infinite-scroll-fix.directive';
import {
	LabelConfigurationComponent
} from '../plan/plan-edit/components/label-configuration/label-configuration.component';
import { SidePanelWrapperComponent } from './components/side-panel-wrapper/side-panel-wrapper.component';
import { ProductGeneralInfoComponent } from './components/product-general-info/product-general-info.component';
import { ProductPhysParamsEditComponent } from './components/product-phys-params-edit/product-phys-params-edit.component';
import { ProductCompressionParamsComponent } from './components/product-compression-params/product-compression-params.component';
import { ProductPackingEditComponent } from './components/product-packing-edit/product-packing-edit.component';
import { ProductMasterGeneralInfoComponent } from './components/product-master-general-info/product-master-general-info.component';
import { MasterProductsTablesComponent } from './components/master-products-tables/master-products-tables.component';
import { ProductPositionDtypeComponent } from './components/dtypes/product-position-dtype/product-position-dtype.component';
import { ProductUsageTableComponent } from './components/product-usage-table/product-usage-table.component';
import { ProductChangeHistoryTableComponent } from './components/product-change-history-table/product-change-history-table.component';
import { ProductsAddExcelModalComponent } from '../planogram/planogram-edit/modals/products-add-excel-modal/products-add-excel-modal.component';
import { MarkdownModule } from 'ngx-markdown';
import { PhNotificationsComponent } from './components/notifications/ph-notifications/ph-notifications.component';
import { PhNotificationsPanelComponent } from './components/notifications/ph-notifications-panel/ph-notifications-panel.component';
import { PhNotificationComponent } from './components/notifications/ph-notification/ph-notification.component';
import { LightenColorPipe } from './pipes/lighten-color.pipe';
import { LocaleDatePipe } from './pipes/locale-date.pipe';
import { PhNotificationsDetailedPanelComponent } from './components/notifications/ph-notifications-detailed-panel/ph-notifications-detailed-panel.component';
import { HighchartsChartComponent } from 'highcharts-angular';
import { PlanogramChatWidgetComponent } from './components/planogram-chat-widget/planogram-chat-widget.component';
import { AllPlanogramChatsWidgetComponent } from './components/all-planogram-chats-widget/all-planogram-chats-widget.component';
import { PlanogramGroupsPanelComponent } from './components/planogram-groups-panel/planogram-groups-panel.component';
import { PlanogramCanvasComponent } from './components/planogram-canvas/planogram-canvas.component';

const SHARED_PIPES = [
	ActiveRoutePipe,
	CheckboxStatusPipe,
	ColorTableRowPipe,
	CutArrayPipe,
	CutStringPipe,
	DtypeInjectorPipe,
	FilterByPipe,
	FilterCallbackPipe,
	GetLinkPipe,
	HasAccessPipe,
	HasExtensionPipe,
	HasFeaturePipe,
	JoinArrayPipe,
	LightenColorPipe,
	LocaleDatePipe,
	LinkTypePipe,
	MeasurementUnitPipe,
	MeasurementUnitTranslatePipe,
	NamesListPipe,
	ProductTypeTitlePipe,
	RequiredFieldPipe,
	SanitizerPipe,
	TableActiveRowPipe,
	ThousandSeparatorPipe,
	TruncatePipe,
	UnitConverterPipe,
];
const SHARED_DIRECTIVES = [
	AutofocusDirective,
	ClickOutsideDirective,
	ColorTagsDirective,
	InfiniteScrollFixDirective,
	MenuDropdownDirective,
	PhTooltipDirective,
	ScrollToDirective,
	ViewedDirective,
	WindowScrollDirective
];
const SHARED_COMPONENTS = [
	AIAssistantComponent,
	AutocompleteComponent,
	AutocompleteSimpleComponent,
	BlogArticlesComponent,
	DataTableComponent,
	DatetimeDtypeComponent,
	DeadlineDateDtypeComponent,
	DownloadMenuComponent,
	DropdownLinksComponent,
	EquipmentModelComponent,
	ExpiredComponent,
	FileUploadComponent,
	FiltersComponent,
	FiltersPanelComponent,
	HeaderComponent,
	HighlightOptionsComponent,
	HighchartsChartComponent,
	HighchartsComponent,
	HotkeyTooltipComponent,
	ImageSelectComponent,
	LastChangeDtypeComponent,
	LayoutHistoryComponent,
	PlanogramChatWidgetComponent,
	AllPlanogramChatsWidgetComponent,
	LayoutParamsDtypeComponent,
	LinkDtypeComponent,
	LoaderComponent,
	MasterProductsTablesComponent,
	MultiExecutionComponent,
	NestedTableComponent,
	NumberDtypeComponent,
	PersonalSettingsComponent,
	PhBarChartComponent,
	PhButtonComponent,
	PhDatepickerComponent,
	PhEditableTableComponent,
	PhGroupedSelectComponent,
	PhIconComponent,
	PhIconWrapperComponent,
	PhLinkButtonComponent,
	PhListComponent,
	PhLoaderComponent,
	PhNotificationComponent,
	PhNotificationsComponent,
	PhNotificationsDetailedPanelComponent,
	PhNotificationsPanelComponent,
	PhSimpleTableComponent,
	PhSnackBarComponent,
	PhTableComponent,
	PickerComponent,
	PlanogramCompletionComponent,
	PlanStatusButtonDtypeComponent,
	ProductCardComponent,
	ProductCardDrawerComponent,
	ProductChangeHistoryTableComponent,
	ProductCompressionParamsComponent,
	ProductGeneralInfoComponent,
	ProductListAddButtonDtypeComponent,
	ProductMasterGeneralInfoComponent,
	ProductNameDtypeComponent,
	ProductPackingEditComponent,
	ProductPhysParamsEditComponent,
	ProductPositionDtypeComponent,
	ProductUsageTableComponent,
	SearchComponent,
	SelectedPanelComponent,
	SidePanelComponent,
	SidePanelWrapperComponent,
	StringDtypeComponent,
	TableComponent,
	TariffComparisonComponent,
	TimePickerComponent,
	TimersMenuComponent,
	TimeTrackerComponent,
	TooltipDtypeComponent,
	TreeCheckboxComponent,
	TreeFilterComponent,
	TreeItemCheckboxComponent,
	TreeMultiFilterComponent,
	TreeRadioComponent,
	UploadPhotoComponent,
	UsersActivityComponent,
	UserLogoGenerateComponent,
	ZoomComponent,
	PlanogramGroupsPanelComponent,
    PlanogramCanvasComponent
];

@NgModule({
	declarations: [
		ConnectTypeModalComponent,
		FilterProductsModalComponent,
		PhotoReportModalComponent,
		ConfirmModalComponent,
		InfoModalComponent,
		PlanogramComponent,
		ExecutionStandComponent,
		RotateProductsModalComponent,
		ComplexDeadlineModalComponent,
		CustomHeader,
		ConfigureTableColumnsModalComponent,
		FilterLibraryModalComponent,
		EquipmentsDownloadModalComponent,
		EquipmentCreateNameModalComponent,
     	ColumnsSettingsModalComponent,
      	BarChartSettingsModalComponent,
        ImagesViewModalComponent,
        OnboardingModalComponent,
        GetFullVersionModalComponent,
		AIRuleComponent,
		PlanogramsWorkspaceComponent,
  		WelcomeDemoFormModalComponent,
		PlanogramConfigurationComponent,
		LabelConfigurationComponent,
		ProductsAddExcelModalComponent
	],
	imports: [
		DependencyModule,
		MarkdownModule,
		...SHARED_PIPES,
		...SHARED_DIRECTIVES,
		...SHARED_COMPONENTS
	],
	exports: [
		...SHARED_PIPES,
		...SHARED_DIRECTIVES,
		...SHARED_COMPONENTS,
		DependencyModule,
		ConnectTypeModalComponent,
		FilterProductsModalComponent,
		PhotoReportModalComponent,
		ConfirmModalComponent,
		InfoModalComponent,
		PlanogramComponent,
		ExecutionStandComponent,
		RotateProductsModalComponent,
		ComplexDeadlineModalComponent,
		CustomHeader,
		ConfigureTableColumnsModalComponent,
		FilterLibraryModalComponent,
		EquipmentsDownloadModalComponent,
		AIRuleComponent,
		PlanogramsWorkspaceComponent,
		PlanogramConfigurationComponent,
		LabelConfigurationComponent,
        ProductsAddExcelModalComponent,
		MarkdownModule
	],
	providers: [
		DatePipe,
		MeasurementUnitPipe,
		MeasurementUnitTranslatePipe,
		UnitConverterPipe
	]
})
export class CoreModule {}
